export const toggleInArray = <T>(array: T[], item: T): T[] => {
  return array.includes(item)
    ? array.filter((i) => i !== item)
    : [...array, item];
};

export const ensureSelected = <T>(array: T[], item: T): T[] => {
  return array.includes(item) ? array : [item];
};
